/* global axios */
import ApiClient from './ApiClient';

class EvolutionInstancesAPI extends ApiClient {
  constructor() {
    super('evolution_instances', { accountScoped: true });
  }

  create(data) {
    return axios.post(this.url, data);
  }

  getStatus(instanceId) {
    return axios.get(`${this.url}/${instanceId}/status`);
  }

  getQrCode(instanceId) {
    return axios.get(`${this.url}/${instanceId}/qr_code`);
  }

  destroy(instanceId) {
    return axios.delete(`${this.url}/${instanceId}`);
  }
}

export default new EvolutionInstancesAPI();

